import React, { useState } from 'react';
import { usePWA } from '../context/PWAContext';
import './PWAInstallPrompt.css';

const PWAInstallPrompt: React.FC = () => {
  const { isInstallable, showInstallPrompt, installPrompt, dismissInstallPrompt } = usePWA();
  const [installing, setInstalling] = useState(false);

  if (!isInstallable || !showInstallPrompt) {
    return null;
  }

  const handleInstall = async () => {
    if (!installPrompt) return;

    setInstalling(true);
    try {
      await installPrompt();
      dismissInstallPrompt();
    } catch (err) {
      console.error('[PWA] Install failed:', err);
    } finally {
      setInstalling(false);
    }
  };

  return (
    <div className="pwa-install-prompt">
      <div className="pwa-install-content">
        <div className="pwa-icon">📱</div>
        <div className="pwa-text">
          <h3>Install App</h3>
          <p>Add Clinical Trial Platform to your device for quick access and offline support</p>
        </div>
        <div className="pwa-actions">
          <button className="pwa-install-btn" onClick={handleInstall} disabled={installing}>
            {installing ? 'Installing...' : 'Install'}
          </button>
          <button className="pwa-dismiss-btn" onClick={dismissInstallPrompt} disabled={installing}>
            Later
          </button>
        </div>
      </div>
    </div>
  );
};

export default PWAInstallPrompt;
